module.exports = __webpack_public_path__ + "img/202407_05.f2940e84.jpg";